import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

let refreshing = null;

api.interceptors.response.use(
  (r) => {
    if (["post", "patch", "put"].includes(r.config?.method) && !r.config?.url?.includes("/auth/")) window.dispatchEvent(new Event("rb-pro-changed"));
    return r;
  },
  async (err) => {
    const orig = err.config;
    if (err.response?.status === 401 && !orig._retry && !orig.url?.includes("/auth/")) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
        await refreshing;
        return api(orig);
      } catch {
        // fall through
      }
    }
    if (err.response?.status === 403 && typeof err.response?.data?.detail === "string" && err.response.data.detail.includes("Pro feature")) {
      window.dispatchEvent(new Event("rb-pro-changed"));
    }
    return Promise.reject(err);
  }
);

export function apiError(e) {
  const d = e.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (d && typeof d.msg === "string") return d.msg;
  return "Something went wrong. Please try again.";
}

export default api;
